export default __webpack_public_path__ + "static/media/alexandr.9837d99e.png";